import Nonpayment from './Nonpayment';

export default Nonpayment;
